/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.InsightCompanyData = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The InsightCompanyData model module.
   * @module model/InsightCompanyData
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>InsightCompanyData</code>.
   * @alias module:model/InsightCompanyData
   * @class
   */
  var exports = function() {
    var _this = this;












  };

  /**
   * Constructs a <code>InsightCompanyData</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InsightCompanyData} obj Optional instance to populate.
   * @return {module:model/InsightCompanyData} The populated <code>InsightCompanyData</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Domain')) {
        obj['Domain'] = ApiClient.convertToType(data['Domain'], 'String');
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('LegalName')) {
        obj['LegalName'] = ApiClient.convertToType(data['LegalName'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('CountryCode')) {
        obj['CountryCode'] = ApiClient.convertToType(data['CountryCode'], 'String');
      }
      if (data.hasOwnProperty('FoundedYear')) {
        obj['FoundedYear'] = ApiClient.convertToType(data['FoundedYear'], 'Integer');
      }
      if (data.hasOwnProperty('Employees')) {
        obj['Employees'] = ApiClient.convertToType(data['Employees'], 'Integer');
      }
      if (data.hasOwnProperty('Raised')) {
        obj['Raised'] = ApiClient.convertToType(data['Raised'], 'Integer');
      }
      if (data.hasOwnProperty('AnnualRevenue')) {
        obj['AnnualRevenue'] = ApiClient.convertToType(data['AnnualRevenue'], 'Integer');
      }
      if (data.hasOwnProperty('URI')) {
        obj['URI'] = ApiClient.convertToType(data['URI'], 'String');
      }
      if (data.hasOwnProperty('ImageURI')) {
        obj['ImageURI'] = ApiClient.convertToType(data['ImageURI'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {String} Domain
   * @default ''
   */
  exports.prototype['Domain'] = '';
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} LegalName
   * @default ''
   */
  exports.prototype['LegalName'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {String} CountryCode
   * @default ''
   */
  exports.prototype['CountryCode'] = '';
  /**
   * @member {Integer} FoundedYear
   */
  exports.prototype['FoundedYear'] = undefined;
  /**
   * @member {Integer} Employees
   */
  exports.prototype['Employees'] = undefined;
  /**
   * @member {Integer} Raised
   */
  exports.prototype['Raised'] = undefined;
  /**
   * @member {Integer} AnnualRevenue
   */
  exports.prototype['AnnualRevenue'] = undefined;
  /**
   * @member {String} URI
   * @default ''
   */
  exports.prototype['URI'] = '';
  /**
   * @member {String} ImageURI
   * @default ''
   */
  exports.prototype['ImageURI'] = '';



  return exports;
}));


